import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from "rxjs";
import { ApiUtils } from "../../core_modules/utils/api-utils/api-utils";
import {BaseApiService} from "../../core_modules/common/services/base-api.service";
import {HttpClient} from "@angular/common/http";
import {SharedService} from "../../core_modules/common/services/shared.service";

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseApiService<any> {
  static API = 'user';

  constructor(
    readonly http: HttpClient,
    override readonly sharedService: SharedService
  ) {
    super(http, sharedService);
  }

  protected getApi(): string {
    return UserService.API;
  }

  logOutUser() {
    const api = `${this.getApi()}/log-out`;
    const req = ApiUtils.getRequest(api);
    return this.http.get(req.url);
  }

  getAuthenticatedUser(showMessage?: boolean): Observable<any> {
    const api = `${this.getApi()}/authenticated`;
    const req = ApiUtils.getRequest(api);
    return this.httpClient.get(req.url).pipe(
      map((res: any) => {
        if (showMessage) {
          this.sharedService.getHttpSuccessResponseMessage(res);
        }
        return res;
      }),
      catchError((error) => {
        this.sharedService.getServerErrorMessage(error);
        return throwError(() => error);
      })
    );
  }

  sendUserOtp(): Observable<any> {
    const api = `${this.getApi()}/send/otp`;
    const req = ApiUtils.getRequest(api);
    return this.httpClient.get<any>(req.url, {}).pipe(
      map((res: any) => {
        this.sharedService.getHttpSuccessResponseMessage(res);
        return res;
      }),
      catchError((error) => {
        this.sharedService.getServerErrorMessage(error.error);
        return throwError(() => error);
      })
    );
  }

  changePasswordWithOtp(params: Object, showMessage?: boolean): Observable<any> {
    const api = `${this.getApi()}/change/Password`;
    const req = ApiUtils.getRequest(api);
    return this.httpClient.post<any>(req.url, params, {}).pipe(
      map((res: any) => {
        if (showMessage) {
          this.sharedService.getHttpSuccessResponseMessage(res);
        }
        return res;
      }),
      catchError((error) => {
        this.sharedService.getServerErrorMessage(error.error);
        return throwError(() => error);
      })
    );
  }

}
